import type { DefaultTheme } from 'styled-components';

type ThemeColorFn = (theme: DefaultTheme) => string;

export const DEFAULT_IMG_SRC = '/lp/crypto-exclusive-may-25/';

export type ThemeConfig = {
  background: ThemeColorFn;
  borderColor: ThemeColorFn;
  descriptionColor: string;
  hoverBackground: ThemeColorFn;
  hoverText: ThemeColorFn;
};

export const themeConfig: Record<string, ThemeConfig> = {
  blue: {
    background: (theme) => theme.nightBlue,
    borderColor: (theme) => theme.blueSky,
    descriptionColor: 'rgba(255, 255, 255, 0.60)',
    hoverBackground: (theme) => theme.royalBlue,
    hoverText: (theme) => theme.whiteColor,
  },
  yellow: {
    background: (theme) => theme.grayDarkColor,
    borderColor: (theme) => theme.yellow1Color,
    descriptionColor: 'rgba(255, 213, 0, 0.6)',
    hoverBackground: (theme) => theme.whiteColor,
    hoverText: (theme) => theme.blackColor,
  },
};
